import Debugger from "../console/debugger";
import EventBus from "../event_bus";
import AppRenderer from "../../js/app_renderer";
import BookData from "../../js/book_data";


export default class ClassTool {

    constructor() {

    }

    getToolFunction() {
        return [
            {
                //生日同學會
                key: "birthday_party",
                event: () => {
                    AppRenderer.Instance.openFile(BookData.Instance.getItemPath() + "生日同樂會/生日同樂會.exe");
                }
            },
            {
                //榮譽榜
                key: "honor_roll",
                event: () => {
                    AppRenderer.Instance.openFile(BookData.Instance.getItemPath() + "榮譽榜/榮譽榜.exe");
                }
            },
            {
                //倒數計時
                key: "countdown",
                event: () => { }
            },
            {
                //碼表
                key: "stopwatch",
                event: () => { }
            }
        ]
    }
}